var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      class: {
        lightbox__close: true,
        "lightbox__close--white": _vm.color === "white",
        "video__pause lightbox__close--offset":
          _vm.$parent.name === "lightboxVideo"
      }
    },
    [
      _c("svg", { staticClass: "lightbox__close__icon" }, [
        _c("use", { attrs: { "xlink:href": "#close" } })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }